export const FETCH_EXPIRYRETURNDETAILS_INIT_ACTION =
  "FETCH_EXPIRYRETURNDETAILS_INIT_ACTION";
export const FETCH_EXPIRYRETURNDETAILS_SUCCESS_ACTION =
  FETCH_EXPIRYRETURNDETAILS_INIT_ACTION + "_SUCCESS";
export const FETCH_EXPIRYRETURNDETAILS_FAIL_ACTION =
  FETCH_EXPIRYRETURNDETAILS_INIT_ACTION + "_ERROR";

export const FETCH_EXPIRYRETURNSEARCH_INIT_ACTION =
  "FETCH_EXPIRYRETURNSEARCH_INIT_ACTION";
export const FETCH_EXPIRYRETURNSEARCH_SUCCESS_ACTION =
  FETCH_EXPIRYRETURNSEARCH_INIT_ACTION + "_SUCCESS";
export const FETCH_EXPIRYRETURNSEARCH_FAIL_ACTION =
  FETCH_EXPIRYRETURNSEARCH_INIT_ACTION + "_ERROR";

export const FETCH_EXPIRYRETURNVIEW_INIT_ACTION =
  "FETCH_EXPIRYRETURNVIEW_INIT_ACTION";
export const FETCH_EXPIRYRETURNVIEW_SUCCESS_ACTION =
  FETCH_EXPIRYRETURNVIEW_INIT_ACTION + "_SUCCESS";
export const FETCH_EXPIRYRETURNVIEW_FAIL_ACTION =
  FETCH_EXPIRYRETURNVIEW_INIT_ACTION + "_ERROR";

export const FILTER_BY_EXPIRYRETURN_STATUS_INIT_ACTION =
  "FILTER_BY_EXPIRYRETURN_STATUS_INIT_ACTION";
export const FILTER_BY_EXPIRYRETURN_STATUS_SUCCESS_ACTION =
  FILTER_BY_EXPIRYRETURN_STATUS_INIT_ACTION + "_SUCCESS";
export const FILTER_BY_EXPIRYRETURN_STATUS_FAIL_ACTION =
  FILTER_BY_EXPIRYRETURN_STATUS_INIT_ACTION + "_ERROR";

export function ExpiryReturn() {
  return { type: FETCH_EXPIRYRETURNDETAILS_INIT_ACTION };
}

export function ExpiryReturnsSelectedPage(value) {
  return {
    type: FETCH_EXPIRYRETURNDETAILS_INIT_ACTION,
    value
  };
}

export function ExpiryReturnsSearch(value) {
  return {
    type: FETCH_EXPIRYRETURNSEARCH_INIT_ACTION,
    value
  };
}

export function ExpiryReturnsSearchSelectedPage(value) {
  return {
    type: FETCH_EXPIRYRETURNSEARCH_INIT_ACTION,
    value
  };
}

export function ExpiryReturnView(value) {
  return {
    type: FETCH_EXPIRYRETURNVIEW_INIT_ACTION,
    value
  };
}

export function FilterSearchExpiryUser(value) {
  return {
    type: FILTER_BY_EXPIRYRETURN_STATUS_INIT_ACTION,
    value
  };
}

export function fltrExpiryUserPagetn(value) {
  return {
    type: FILTER_BY_EXPIRYRETURN_STATUS_INIT_ACTION,
    value
  };
}
